export enum RouteConstants {
  AppointmentDetailsForMe = '/appointments/:appointmentId',
  AppointmentDetailsForMember = '/members/:memberId/appointments/:appointmentId',
  AppointmentsForMe = '/appointments',
  AppointmentsForMember = '/members/:memberId/appointments',
  BodyComposition = '/body-composition',
  Error = 'error',
  GroupClasses = '/group-classes/:token',
  GroupClassesDetails = '/group-classes/:appointmentTypeId/detail',
  Login = '/login',
  Meeting = '/meetings/:token',
  Root = '/',
  Scheduling = '/scheduling',
  SchedulingLink = '/scheduling-link',
  SelfSignIn = '/self-sign-in/:token',
  ShortSelfSignIn = '/s/:token',
}
